<div
  class="time-picker-wrapper"
  style="
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
  "
>
  <kpi4me-text-element
    #inputField
    class="form-field-no-padding"
    style="width: 100%"
    [formControlElement]="textFormControl"
    [data]="textElementData"
    [hideLabel]="true"
    (keydown.enter)="params.api.stopEditing()"
    placeholder="HH:mm"
  />

  <ngx-material-timepicker
    [format]="24"
    (timeChanged)="onTimeChanged($event)"
  />
</div>
